
export default {
  props: {
    pageInfo: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {};
  },
  computed: {
  },
  watch: {},
  methods: {
    handleCurrentChange(val) {
      this.$emit("changePage", val);
    }
  }
};
